import { Component, OnInit, Input } from "@angular/core";
import { CeRequestOptions } from "../../request-header/request-header.component";
import { FormGroup, AbstractControl, FormArray } from "@angular/forms";
import { ExperimentDetailsFormModel } from "../../services/request-form.service";
import { Settings } from "../../../settings";
import { SettingsService } from "research.web.settings";

@Component({
  selector: "app-experiment-design-form",
  templateUrl: "./experiment-design-form.component.html"
})
export class ExperimentDesignFormComponent implements OnInit {
  @Input("options") public ceRequestOptions: CeRequestOptions;
  @Input("experimentDesignFormGroup") public experimentDesignFormGroup: FormGroup;
  @Input("requestDetails") public requestDetails: ExperimentDetailsFormModel;
  public settings: Settings;

  constructor(private settingsService: SettingsService) {
    this.settings = this.settingsService.get<Settings>("_appSettings");
  }

  ngOnInit(): void {}

  public control = (controlName: string): AbstractControl => {
    return this.experimentDesignFormGroup.get(controlName);
  };

  public get isWheatRequest(): boolean {
    return this.requestDetails.crop === this.settings.wheatCropId;
  }

  public get pottingInstructionsEnabled(): boolean {
    var treatments = this.experimentDesignFormGroup.get('treatments') as FormArray;
    return treatments.controls[0].get('pottingInstructions').enabled;
  } 

  public get pollinationInstructionsEnabled(): boolean {
    return this.experimentDesignFormGroup.get('pollinationInstructions').enabled;
  } 

  public get harvestInstructionsEnabled(): boolean {
    return this.experimentDesignFormGroup.get('harvestInstructions').enabled;
  } 
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/experiment-design-form/experiment-design-form.component.ts